import React, { useContext, useEffect, useState, forwardRef, useCallback } from 'react';
import { withStyles, Divider } from '@material-ui/core';
import DataContext from '../../data/DataContext';
import { openLink } from '../../util/utilNative';
import Arrow from '../../../asset/img/ArrowRight.svg';
import Alarm from '../../../asset/img/Push1.svg';
import moment from 'moment';
import CarouselEmbla from '../../carousel/CarouselEmbla';

const styles = (theme) => ({
  root: {
    display: 'flex',
    letterSpacing: '-0.5px',
    flexDirection: 'column',
    background: '#e6e1d6',
    zIndex: 10,
    height: '3.125rem',
    justifyContent: 'center',
  },
  message: {
    fontSize: theme.font.size15, // "15px",
    borderRadius: '0.75rem',
    flexWrap: 'wrap',
    color: theme.color.message.color,
    maxWidth: '100%',
    zIndex: 10,
    wordWrap: 'break-word',
  },
  text: {
    padding: '0.5625rem 1.25rem',
  },
  date: {
    color: theme.color.message.date,
    fontSize: theme.font.size11,
    fontWeight: '300',
    alignSelf: 'flex-end',
    margin: '0.3125rem 0 0.375rem 0',
    textAlign: 'center',
  },
  list: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  },
  vertical: {
    height: 'auto',
  },
  buttonText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minHeight: '2.5rem',
    color: theme.color.message.color,
    padding: '0 0.625rem 0 0.375rem', // carousel에 기본 padding 좌우로 10px씩
    fontSize: theme.font.size12,
    textAlign: 'start',
    fontWeight: 'normal', //600
    fontStretch: 'normal',
    lineHeight: '1.25',
    letterSpacing: 'normal',
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '0.375rem',
  },
  bannerText: {
    wordBreak: 'keep-all',
  },
  arrow: {
    width: theme.font.size12,
    height: theme.font.size12,
    backgroundSize: 'contain',
    backgroundImage: `url(${Arrow})`,
    padding: '.5em',
    margin: '0 1.1875rem 0 0.25rem',
  },
  alarm: {
    width: '1rem',
    height: '1rem',
  },
  buttonContainer: {
    // width: "100%",
    minWidth: '100%',
    alignSelf: 'start',
    // outline: 0,
    border: 'none',
    background: 'transparent',
    // '&:active': {
    //   background: 'rgba(38, 38, 38, 0.1)',
    // },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
});

const Inform = forwardRef((props, ref) => {
  const {
    classes,
    data,
    goNext,
    goPrev,
    gotoIndex,
    canScrollNext,
    canScrollPrev,
    activeSlide,
  } = props;

  const context = useContext(DataContext);

  const handleClick = (link) => {
    // if (!ref.clickAllowed()) {
    //   return;
    // }
    var type = link.type;
    var url = link.url;
    var event_action = link?.event_action;

    openLink(context, type, url, event_action);
  };

  const informList = data?.items;
  const listLength = informList ? informList.length : 0;

  return (
    informList &&
    informList.map((informData, index) => (
      <button
        key={`if-${index}`}
        type="button"
        className={classes.buttonContainer}
        disabled={context.conversationEnd}
        onClick={() => handleClick(informData)}
        title={`${
          informData.type.toLowerCase() === 'external'
            ? context.string.aria.external + ','
            : ''
        } ${informData.title}`}
        aria-hidden={activeSlide !== index}
        tabIndex={activeSlide !== index ? '-1' : ''}
      >
        <div className={classes.buttonText}>
          <div className={classes.iconBox}>
            <img className={classes.alarm} src={Alarm} alt="" />
          </div>
          <div className={classes.bannerText}>{informData.title}</div>
          <div className={classes.arrow} />
          {/* <div>
            {index + 1}/{listLength}
          </div> */}
        </div>
      </button>
    ))
  );
});

function IB(props) {
  const { classes, data } = props;
  const options = {
    align: 'start',
    dragFree: false,
    containScroll: true,
    speed: 8,
    loop: true,
  };

  return (
    <>
      <div className={[classes.root].join(' ')}>
        <div className={[classes.message].join(' ')}>
          <CarouselEmbla
            className={classes.carousel}
            component={withStyles(styles)(Inform)}
            data={data}
            options={options}
            autoplay={true}
            // itemCount={itemCount}
            arrowsIB={true}
            indicator={false}
          />

          {/* <Carousel
            component={withStyles(styles)(Inform)}
            data={data}
            indicator={false}
            dragFree={false}
            scrollSpeed={15}
            arrows={true}
            // ariaLabel={place}
          /> */}
        </div>
      </div>
    </>
  );
}
export default withStyles(styles)(IB);
